import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const PORTAL_API_URL = `${BACKEND_URL}/api`;

const portalApi = axios.create({
  baseURL: PORTAL_API_URL,
});

portalApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('portal_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

portalApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('portal_token');
      localStorage.removeItem('portal_client');
      if (typeof window !== 'undefined' && !window.location.pathname.startsWith('/portal/login')) {
        window.location.href = '/portal/login';
      }
    }
    return Promise.reject(error);
  }
);

export const savePortalSession = (token, client) => {
  localStorage.setItem('portal_token', token);
  localStorage.setItem('portal_client', JSON.stringify(client));
};

export const getPortalClient = () => {
  try {
    const raw = localStorage.getItem('portal_client');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const clearPortalSession = () => {
  localStorage.removeItem('portal_token');
  localStorage.removeItem('portal_client');
};

export default portalApi;
